import { getErrorMessage } from '../../utils/errorMessage';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getDeviceId } from '../../utils/deviceId';

const identityApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

identityApi.interceptors.request.use(config => {
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});

function unwrap(response) {
  const payload = response?.data;
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '身份服务暂时不可用');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function createWechatLoginSession(context = {}) {
  return unwrap(await identityApi.post('/auth/wechat/session', { agreed: true, ...context }));
}

export async function pollWechatLoginSession(sessionId, pollToken) {
  return unwrap(await identityApi.post(
    `/auth/wechat/session/${encodeURIComponent(sessionId)}/poll`,
    { poll_token: pollToken },
  ));
}

function authConfig() {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export async function createWechatBindingSession() {
  return unwrap(await identityApi.post('/auth/wechat/bind/session', {}, authConfig()));
}

export async function pollWechatBindingSession(sessionId, pollToken) {
  return unwrap(await identityApi.post(
    `/auth/wechat/bind/session/${encodeURIComponent(sessionId)}/poll`,
    { poll_token: pollToken },
    authConfig(),
  ));
}

export async function sendEmailBindingCode(email) {
  return unwrap(await identityApi.post('/auth/email/bind/code', { email }, authConfig()));
}

export async function confirmEmailBinding(input) {
  return unwrap(await identityApi.post('/auth/email/bind/confirm', input, authConfig()));
}

export async function sendEmailReauthCode() {
  return unwrap(await identityApi.post('/auth/email/reauth/code', {}, authConfig()));
}

export async function verifyEmailReauthCode(code) {
  return unwrap(await identityApi.post('/auth/email/reauth/verify', { code }, authConfig()));
}

export async function createWechatReauthSession() {
  return unwrap(await identityApi.post('/auth/wechat/reauth/session', {}, authConfig()));
}

export async function pollWechatReauthSession(sessionId, pollToken) {
  return unwrap(await identityApi.post(
    `/auth/wechat/reauth/session/${encodeURIComponent(sessionId)}/poll`,
    { poll_token: pollToken },
    authConfig(),
  ));
}

export async function sendEmailRegistrationCode(email) {
  return unwrap(await identityApi.post('/auth/email/register/code', { email }));
}

export async function verifyEmailRegistrationCode(email, code) {
  return unwrap(await identityApi.post('/auth/email/register/verify', { email, code }));
}

export async function sendPasswordResetCode(email) {
  return unwrap(await identityApi.post('/auth/email/password-reset/code', { email }));
}

export async function confirmPasswordReset(input) {
  return unwrap(await identityApi.post('/auth/email/password-reset/confirm', input));
}

export function getWechatLoginError(error, fallback = '微信登录服务暂时不可用，请稍后重试。') {
  return getErrorMessage(error, fallback);
}
